export enum  Action {
CREATE = 'CREATE',
UPDATE ='UPDATE',
DELETE = 'DELETE',
SEARCH = 'SEARCH',
DETAIL = 'DETAIL'
}